module.exports = __webpack_public_path__ + "banners_logo_stadia.webp";